import axios from "axios";
import Cookies from "js-cookie";
import toast from "react-hot-toast";

axios.defaults.baseURL = process.env.REACT_APP_BASE_API;
axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  const token = Cookies.get("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const sessionExpired = sessionStorage.getItem("sessionExpired");

      if (!sessionExpired) {
        sessionStorage.setItem("sessionExpired", "true");

        Cookies.remove("token");
        Cookies.remove("userid");
        Cookies.remove("user_role");

        toast.error("Session expired. Please login again.");

        setTimeout(() => {
          window.location.href = "/login";
        }, 500);
      }
    }

    return Promise.reject(error);
  }
);

export default axios;